// extracted by mini-css-extract-plugin
export default {"progressRing":"Ring_progressRing__HmZQp","dash":"Ring_dash__E7HMB"};